import { connect } from 'react-redux';
import { actions } from '../../../../../redux/modules/laboratoristas';
import LaboratoristasList from './LaboratoristasList';

const ms2p = state => {
    return {
        ...state.laboratoristas,
    }
}

const md2p = { ...actions };

export default connect(ms2p, md2p)(LaboratoristasList);